<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('task.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('task.pageTitle'),
            href: '/admin/tasks'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-items-center ts-space-x-3">
          <button
            v-if="isAllowBack"
            @click.prevent="$router.go(-1)"
            class=" ts-w-6 ts-h-6 ts-bg-red-600 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
          >
            <Icon type="md-arrow-round-back" class="ts-text-white" size="20" />
          </button>
        </div>

        <div class="ts-p-2 ts-rounded-md">
          <div class="ts-grid ts-grid-cols-3 ts-gap-5">
            <div
              class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
            >
              <Connector />
              <BasicInfo
                v-model="model"
                :validate="errors"
                :resources="{ status, priority, milestones }"
              />
            </div>
            <div
              class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3 ts-relative"
            >
              <Connector />
              <DateForm
                v-model="model"
                :validate="errors"
                :resources="{ sites }"
                @add-project="addProjectFromChild"
                @add-milestone="addMilestoneFromChild"
              />
            </div>

            <div
              class="ts-w-full ts-h-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-3"
            >
              <Client v-model="model" />
            </div>
          </div>
          <AttachFile v-model="model" :validate="errors" />
        </div>
      </ts-card-wrapper>
      <!-- <div class="ts-w-full ts-h-1 ts-bg-gray-300"></div> -->
      <ts-card-wrapper>
        <SubTask v-model="model" />
      </ts-card-wrapper>
      <ts-card-wrapper>
        <div class="row">
          <div
            class="col-md-12 ts-flex ts-items-center ts-justify-end ts-space-x-3"
          >
            <ts-button
              :disabled="loading"
              @click.prevent="$router.push({ name: 'task' })"
              >{{ $t('cancel') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSaveAddNew"
              outline
              color="primary"
              >{{ $t('saveAddNew') }}
            </ts-button>
            <ts-button
              :disabled="loading"
              @click.prevent="onSave"
              color="primary"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import AttachFile from './components/attach-file.vue'
import Connector from './components/connector.vue'
import BasicInfo from './components/basic-info.vue'
import DateForm from './components/date-form.vue'
import Client from './components/client.vue'
import SubTask from './components/sub-task.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    AttachFile,
    Connector,
    BasicInfo,
    DateForm,
    Client,
    SubTask
  },
  data() {
    return {
      errors: new Errors(),
      status: [],
      priority: [],
      projects: [],
      milestones: [],
      sites: [],
      tasks: [],
      loading: false,
      model: {
        title: '',
        status_id: 1,
        priority_id: '',
        owner_id: '',
        member: [],
        estimate_date: [],
        actual_date: [],
        project_id: '',
        milestone_id: '',
        site_profile_id: '',
        dependency_task_id: '',
        client_name: '',
        client_mobile_number: '',
        client_address: '',
        remarks: '',
        files: [],
        sub_tasks: [],
        fee_amount: ''
      }
    }
  },
  computed: {
    isAllowBack() {
      return Object.keys(this.$route.query).length
    }
  },
  created() {
    this.fetchModel()
  },
  methods: {
    ...mapActions('projectMgt/taskProfile', ['formViewModel', 'store']),
    fetchModel() {
      this.loading = true
      this.formViewModel({
        fnName: 'status,priority,project,site,milestone'
      })
        .then(response => {
          this.status = response.data.status
          this.priority = response.data.priority
          this.projects = response.data.project
          this.sites = response.data.site
          this.milestones = response.data.milestone
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onSave() {
      const data = this.serializeData()
      this.loading = true
      this.errors.clear()
      this.store(data)
        .then(response => {
          this.$toasted.success(response.message)
          // this.$router.push({ name: 'task' })
          this.$router.go(-1)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    onSaveAddNew() {
      const data = this.serializeData()
      this.loading = true
      this.errors.clear()
      this.store(data)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => (this.loading = false))
    },
    serializeData() {
      const formData = new FormData()
      const keys = Object.keys(this.model)

      keys.forEach(key => {
        if (key !== 'files' && key !== 'sub_tasks') {
          if (Array.isArray(this.model[key])) {
            for (let n = 0; n <= this.model[key].length - 1; n++) {
              formData.append(key + `[${n}]`, this.model[key][n])
            }
          } else {
            formData.append(key, this.model[key])
          }
        }

        if (key == 'files') {
          for (var i = 0; i < this.model.files.length; i++) {
            let file = this.model.files[i]

            formData.append('files[' + i + ']', file)
          }
        }

        if (key == 'sub_tasks') {
          for (let i = 0; i <= this.model.sub_tasks.length - 1; i++) {
            const subKey = Object.keys(this.model.sub_tasks[i])
            subKey.forEach(sKey => {
              let value = this.model.sub_tasks[i][sKey]
              if (Array.isArray(value)) {
                for (let n = 0; n <= value.length - 1; n++) {
                  formData.append(
                    'sub_tasks[' + i + '][' + sKey + `][${n}]`,
                    this.model.sub_tasks[i][sKey][n]
                  )
                }
              } else {
                formData.append(
                  'sub_tasks[' + i + '][' + sKey + ']',
                  this.model.sub_tasks[i][sKey]
                )
              }
            })
          }
        }
      })

      return formData
    },
    addProjectFromChild(project) {
      this.projects.push(project)
    },
    addMilestoneFromChild(milestone) {
      this.milestones.push(milestone)
    },
    clearInput() {
      this.model.title = ''
      this.model.status_id = 1
      this.model.priority_id = ''
      this.model.owner_id = ''
      this.model.member = []
      this.model.estimate_date = []
      this.model.actual_date = []
      this.model.project_id = this.$route.query.project_id
      this.model.milestone_id = this.$route.query.milestone_id
      this.model.site_profile_id = ''
      this.model.dependency_task_id = ''
      this.model.client_name = ''
      this.model.client_mobile_number = ''
      this.model.client_address = ''
      this.model.remarks = ''
      this.model.files = []
      this.model.sub_tasks = []
      this.model.fee_amount = ''
    }
  }
}
</script>
